if (!Enum) {
    var Enum = {};
}

Enum.MEDICAL_INDICATION = {
    CAN_WALK: 'CAN_WALK',
    SHOULD_LIE: 'SHOULD_LIE'
};

Object.freeze(Enum.MEDICAL_INDICATION);